import { Injectable } from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {}

    init() {
        // Task / Work Item Icons
        this.matIconRegistry.addSvgIcon(
            "parent-task-icon",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/parent-task-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'parent-bug-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/parent-bug-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "task-icon",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/task-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "sub-task-icon",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/sub-task-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "bug-task-icon",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/bug-task-icon.svg")
        );

        // Priority Icons
        this.matIconRegistry.addSvgIcon(
            "p0",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/p0.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "p1",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/p1.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "p2",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/p2.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "p3",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/p3.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "p4",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/p4.svg")
        );

        // Miscellaneous Icons
        this.matIconRegistry.addSvgIcon(
            "chevron-down-accent",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/chevron-down-accent.svg")
        );

        this.matIconRegistry.addSvgIcon(
            "upload-attachment",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/upload-attachment.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'mic-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/mic-icon.svg")
        );


        this.matIconRegistry.addSvgIcon(
            'upload-attachment-cloud',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/upload_cloud.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'active-up-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/active-up-arrow.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'active-down-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/active-down-arrow.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'calendar',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/calendar.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'users',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/users.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'copy',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/copy.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'clock-9',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/clock-9.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'mode',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/mode.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'chevron-right-2',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/chevron-right-2.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'Edit',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/Edit.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'trash-2',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/trash-2.svg")
        );
        // Holidays tab of Manage Organization (PT-16533)
        this.matIconRegistry.addSvgIcon(
            'holiday-tab',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/holiday-tab.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'link-2',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/link-2.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'upload',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/upload.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'AI',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/AI.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'search-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/search-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'filter',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/filter.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'meetings-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/meetings-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'briefCase',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/briefCase.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'chevron-left',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/chevron-left.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'chevron-right',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/chevron-right.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'video-join-meet',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/video-join-meet.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'jira',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/jira.svg")
        );

        this.matIconRegistry.addSvgIcon(
            'plus-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/plus-icon.svg"));
        this.matIconRegistry.addSvgIcon(
            'DELAYED',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/DELAYED.svg")
        )
        this.matIconRegistry.addSvgIcon(
            'WATCHLIST',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/WATCHLIST.svg")
        )
        this.matIconRegistry.addSvgIcon(
            'ONTRACK',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/ONTRACK.svg")
        )
        this.matIconRegistry.addSvgIcon(
            'NOTSTARTED',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/NOTSTARTED.svg")
        )
        this.matIconRegistry.addSvgIcon(
            'COMPLETED',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/COMPLETED.svg")
        )
        //     arrow-down-primary
        this.matIconRegistry.addSvgIcon(
            'arrow-down-primary',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/arrow-down-primary.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'up-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/up-arrow.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'down-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/down-arrow.svg")
        )

        // Icons migrated from app-svg-icon
        this.matIconRegistry.addSvgIcon(
            'close',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/close.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'plus',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/plus.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'delete-icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/delete-icon.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'ask-with-question-mark',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/ask-with-question-mark.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'climb',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/climb.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'no_member_list',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/no_member_list.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'firstDate',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/firstDate.svg")
        );
        this.matIconRegistry.addSvgIcon(
            'secondDate',
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img-and-icons/secondDate.svg")
        );
    }

}
